module.exports = __webpack_public_path__ + "assets/img/chicken_wing_active.8a5f83e1.png";